import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "./LangContext";
import { IMAGES } from "@/data/content";

export default function ImageBreak() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="image-break-section"
      className="relative h-[70vh] w-full overflow-hidden md:h-screen"
    >
      <motion.img
        src={IMAGES.imageBreak}
        alt="Sport outdoor lifestyle accessories"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover grayscale"
      />
      <div className="absolute inset-0 bg-black/10" />
      <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between md:bottom-10 md:left-12 md:right-12">
        <span className="font-mono text-[0.68rem] uppercase tracking-[0.22em] text-white">
          {t.imageBreak.label}
        </span>
        <span className="font-mono text-[0.68rem] uppercase tracking-[0.22em] text-white/70">
          04
        </span>
      </div>
    </section>
  );
}
